import React, { useEffect, useState } from 'react'
import {
	AppBar,
	Backdrop,
	Badge,
	BottomNavigation,
	BottomNavigationAction,
	Box,
	CircularProgress,
	Drawer,
	Hidden,
	IconButton,
	List,
	ListItemIcon,
	ListItemText,
	SvgIcon,
	Tab,
	useMediaQuery,
} from '@material-ui/core'
import {
	bottomAppBarStyle,
	closeBtnWrapperStyle,
	containerStyle,
	drawerBottomStyle,
	mainContentChildrenStyle,
	mainContentStyle,
	mainWithoutMenuContentStyle,
	menuDisabledItemStyle,
	menuItemStyle,
	pageTitleStyle,
	profileToggleStyle,
	sidebarMobileStyle,
	TabsContainer,
} from './care.style'
import { loadingState, observer } from '~/common/mobx.decorator'
import { appStore, authStore, masterStore, routerStore } from '~/stores'
import { careStore } from './care.store'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import {
	Breadcumbs,
	Footer,
	HeaderBar,
	LoadingBrandingHeader,
	LoadingEducationHeader,
	LoadingUnitedAnesthesiaHeader,
	LoadingGHRHeader,
	LoadingBrandingFooter,
	LoadingEducationFooter,
	LoadingUnitedAnesthesiaFooter,
	LoadingGHRFooter,
} from '~/components/layout'
import { Typography } from '~/components/typography'
import { CloseSideBarSvg, LogoutSvg, MenuSvg, NotificationSvg, PrivacySvg } from '~/components/icons'
import { ACTIONS, PATHS } from '~/common/constants'
import { ListItem } from '~/components/list-item/list-item.component'
import { careFindJobStore } from '~/features/care-find-job/care-find-job.store'
import { PrivacyPolicyFeature } from '~/features/privacy-policy/privacy-policy.feature'
import { UserAccount } from '~/components/user-account'
import { NotifyDialog } from '~/components/notify'
import { careActivationStore } from '~/features/care-activation/care-activation.store'
import { Link } from 'react-router-dom'
import { breadcrumbsStore } from '~/stores/breadcrumb.store'
import { useEffectOnce } from 'react-use'
import { Button } from '~/components/button'
import { Banner } from '~/components/banner'
import { quickApplyStore } from '~/features/quick-apply/quick-apply.store'
import { QuickApply } from '~/features/quick-apply/quick-apply-component'
import ApplyJobDialog from '~/components/apply-job-dialog'
import { careJobDetailStore } from '~/features/care-jobs/detail/care-job-detail.store'
import { SuccessApplyDialog } from '~/components/apply-job-dialog/success-apply-dialog'
import { returnTabItemPath } from '~/common/helpers'
import { notificationStore } from '~/features/notifications/notification.store'
import { isNil } from 'lodash'
import { AdditionalInfoApplyDialogComponent } from '~/components/additional-info-apply-dialog'
import { logClickEvent } from '~/common/tracking/event-client.tracking'
import { COMMON_EVENT_CLICK_TRACKING } from '~/common/constants/tracking.constant'
import { MatchProfessionDialog } from '~/components/match-profession-dialog'
import { credentialsStore } from '~/features/credentials/credentials-feature.store'
import { CheckoutSuccessDialog } from '~/components/checkout-success-dialog'
import { SuccessCheckinDialog } from '~/components/success-checkin-dialog'
import { DEFAULT_LOGO, LOGO_URLS } from '~/components/layout/image-urls'
import { GlobalSearch } from '~/components/layout/global-search/global-search'
import { SubHeader } from '~/components/sub-header'

export const CareLayout = observer(({ children }) => {
	const loading = loadingState(ACTIONS.careStore.fetchWorkerBasicInfo)
	const {
		getActiveFeature,
		showProfileSidebar,
		toogleProfileSidebar,
		logout,
		customHeader,
		fetchWorkerBasicInfo,
		fetchWorkerAvatar,
		fetchCompanyInfo,
	} = careStore
	const { setShowCheckInError, showCheckinError } = careJobDetailStore
	const {
		fetchTypeJobs,
		fetchSavedFilterNotificationChannels,
		fetchSavedFilterPauseAlertPeriods,
		fetchSavedFilterFrequencies,
		fetchDisciplines,
		fetchWorkerDisciplines,
		fetchDisciplinesCategories,
		fetchReferenceRelationship,
		fetchWorkLocations,
		fetchReasonsForLeaving,
		fetchJobEmploymentTypes,
	} = masterStore
	const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'))
	const { refreshNotifications, totalUnread } = notificationStore
	const { handleSyncAnoAction } = careFindJobStore
	const { t } = useTranslation()
	const [showPrivacy, setShowPrivacy] = useState(false)
	const [marginTop, setMarginTop] = useState(null)
	const [headerHeight, setHeaderHeight] = useState(null)

	const { openQuickApply, setOpenQuickApply } = quickApplyStore
	const { jobId, email } = JSON.parse(window.localStorage.getItem('quickApplyJob')) || {}
	const anoSaveSearch = JSON.parse(window.localStorage.getItem('anoSaveSearch'))
	const isDown1020 = useMediaQuery((theme) => theme.breakpoints.down(1020))
	// const isHideWelcomeLogo = useMediaQuery((theme) => theme.breakpoints.down(1312))

	const { id, workerEmail } = authStore
	useEffectOnce(() => {
		let marginTop = ''
		let headerHeight = ''
		switch (appStore.jobBoardCode) {
			case 'planet':
				marginTop = '91px'
				headerHeight = '160px'
				break
			case 'education':
				marginTop = '131px'
				headerHeight = '200px'
				break
			case 'unitedAnesthesia':
				marginTop = ''
				break
			case 'ghr':
				marginTop = '131px'
				headerHeight = '200px'
				break
			default:
				marginTop = '131px'
				headerHeight = '200px'
				break
		}
		setMarginTop(marginTop)
		setHeaderHeight(headerHeight)

		if (authStore.id) {
			void Promise.all([
				fetchWorkerBasicInfo(),
				fetchWorkerAvatar(),
				fetchSavedFilterNotificationChannels(),
				fetchSavedFilterPauseAlertPeriods(),
				fetchSavedFilterFrequencies(),
				fetchDisciplines(),
				fetchWorkerDisciplines(),
				fetchCompanyInfo(),
				refreshNotifications(),
				fetchWorkLocations(),
				fetchReasonsForLeaving(),
			])
		}
		void Promise.all([fetchTypeJobs(), fetchJobEmploymentTypes(), fetchWorkLocations(), fetchReferenceRelationship(), fetchDisciplinesCategories()])
	})

	useEffect(() => {
		if (id && jobId) {
			if (email === workerEmail) {
				routerStore.goPage(`${PATHS.care.jobs}/${jobId}`)
				window.localStorage.removeItem('quickApplyJob')
			} else {
				window.localStorage.removeItem('quickApplyJob')
			}
		}
	}, [id, workerEmail, email, jobId])

	//how to trigger listener from iframe to parent document window.addEventListener('message', (event) => {
	const handleMessage = (event) => {
		// Do something with the message received from the iframe
		if (event.data === 'complete_and_close') {
			credentialsStore.setEsignUrl('')
		}
	}

	useEffect(() => {
		window.addEventListener('message', handleMessage)
		return () => {
			window.removeEventListener('message', handleMessage)
		}
	}, [])

	useEffectOnce(() => {
		if (authStore.id) {
			async function fetchInitData() {
				await careFindJobStore.fetchSaveSearhFilter()
				await handleSyncAnoAction()
			}

			fetchInitData()
		}
	})

	useEffect(() => {
		if (!isNil(anoSaveSearch) && authStore.id) {
			routerStore.goPage(PATHS.care.search)
		}
		// eslint-disable-next-line
	}, [])

	const LogoUrl = LOGO_URLS[appStore.jobBoardCode] || DEFAULT_LOGO

	const logoWidthMapping = {
		ghr: 163,
		planet: 140,
		education: 145,
		unitedAnesthesia: 225,
	}

	// const welcomeTextMapping = {
	// 	ghr: 'Welcome to GHR live!',
	// 	planet: 'Welcome to Planet!',
	// 	education: 'Welcome to Education!',
	// 	unitedAnesthesia: 'Welcome to UA!',
	// }

	const renderHeader = () => {
		switch (appStore.jobBoardCode) {
			case 'planet':
				return (
					<>
						<LoadingBrandingHeader />
						<SubHeader top={marginTop} />
					</>
				)
			case 'education':
				return (
					<>
						<LoadingEducationHeader />
						<SubHeader top={marginTop} />
					</>
				)
			case 'unitedAnesthesia':
				return (
					<>
						<LoadingUnitedAnesthesiaHeader />
					</>
				)
			case 'ghr':
				return (
					<>
						<LoadingGHRHeader />
						<SubHeader top={marginTop} />
					</>
				)
			default:
				return (
					<>
						<LoadingGHRHeader />
						<SubHeader top={marginTop} />
					</>
				)
		}
	}

	const renderFooter = () => {
		if (smDown || authStore.id) {
			return <Footer />
		}

		switch (appStore.jobBoardCode) {
			case 'planet':
				return <LoadingBrandingFooter />
			case 'education':
				return <LoadingEducationFooter />
			case 'unitedAnesthesia':
				return <LoadingUnitedAnesthesiaFooter />
			case 'ghr':
				return <LoadingGHRFooter />
			default:
				return <LoadingGHRFooter /> // Default to GHR
		}
	}

	if (loading) {
		return (
			<Backdrop open={loading}>
				<CircularProgress />
			</Backdrop>
		)
	}

	if (careFindJobStore.redirectSignUpLastJobId && authStore.id) {
		routerStore.goPage(`${PATHS.care.jobs}/${careFindJobStore.redirectSignUpLastJobId?.slug}`)
		careFindJobStore.setRedirectSignUpLastJobId(null)
	}

	const handleClosePrivacy = () => {
		setShowPrivacy(false)
	}
	const handleRedirectSignIn = () => {
		logClickEvent(COMMON_EVENT_CLICK_TRACKING.signInBtn, {})
		routerStore.goPage(PATHS.common.signin)
	}
	const handleRedirectSignUp = () => {
		logClickEvent(COMMON_EVENT_CLICK_TRACKING.signUpBtn, {})
		routerStore.goPage(PATHS.common.signup)
	}

	useEffect(() => {
		if (!getActiveFeature()?.useBreadcrumb) {
			breadcrumbsStore.removeBreadcrumb()
		}
	})

	const { name: activeName, code: activeCode } = getActiveFeature() || {}

	return (
		<>
			<div css={containerStyle}>
				<>
					<HeaderBar
						display="flex"
						direction="row"
						justifyContent="space-between"
						onClickFilter={customHeader?.onClickFilter}
						onClickBack={customHeader?.onClickBack}
						className="header-bar"
					>
						{authStore.id ? (
							<>
								<Box width="100%" justifyContent="space-between" display="flex">
									{isDown1020 ? (
										<>
											<IconButton aria-label="left-menu" css={profileToggleStyle} onClick={toogleProfileSidebar}>
												<SvgIcon component={MenuSvg} />
											</IconButton>
											<Box display="flex" justifyContent="center" width="100%">
												<Typography variant="h6" color="text.secondary" css={pageTitleStyle}>
													{t(customHeader?.title || activeName)}
												</Typography>
											</Box>
										</>
									) : (
										<>
											<Box
												display="flex"
												justifyContent="center"
												alignItems="center"
												gridGap={32}
												pl={3}
												style={{ cursor: 'pointer' }}
												onClick={() => {
													routerStore.goPage(PATHS.common.home)
													logClickEvent(COMMON_EVENT_CLICK_TRACKING.welcomeToGHR)
												}}
											>
												<Box className={'wrapper-logo-brand'} style={{ width: `${logoWidthMapping[appStore.jobBoardCode]}px` }}>
													<img
														src={LogoUrl}
														alt={LogoUrl}
														style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', minWidth: logoWidthMapping[appStore.jobBoardCode] }}
														width={logoWidthMapping[appStore.jobBoardCode]}
													/>
												</Box>

												{/* https://mylong.atlassian.net/browse/GHR-5420 */}
												{/* {!isHideWelcomeLogo && routerStore.basePath !== PATHS.care.global_search && (
													<Box>
														<Typography variant="subtitle1" color="primary.main" fontWeight={800} style={{ marginLeft: '20px' }}>
															<span dangerouslySetInnerHTML={{ __html: welcomeTextMapping[appStore.jobBoardCode] }} />
														</Typography>
													</Box>
												)} */}
											</Box>

											<Box className={routerStore.basePath === PATHS.care.global_search ? 'layout-nav fullWidth' : 'layout-nav normal'}>
												{routerStore.basePath !== PATHS.care.global_search && (
													<TabsContainer value={returnTabItemPath(routerStore.basePath)}>
														{careStore.sidebarMenu?.map(({ name, icon: Icon, iconFilled: IconFilled, path, eventId }) => {
															return (
																<Tab
																	onClick={(e) => {
																		logClickEvent(eventId, {})
																	}}
																	disableRipple
																	key={t(name)}
																	component={Link}
																	to={path}
																	value={path}
																	style={{ minWidth: '83px', padding: '20px 1rem' }}
																	label={
																		<Box
																			style={{
																				display: 'flex',
																				justifyContent: 'center',
																				alignItems: 'center',
																				gap: '12px',
																				...(path === returnTabItemPath(routerStore.basePath) && { color: appStore.getTheme.palette.secondary.main }),
																			}}
																		>
																			{path === returnTabItemPath(routerStore.basePath) ? <IconFilled /> : <Icon />}
																			<Typography variant="h4">{t(name)}</Typography>
																		</Box>
																	}
																/>
															)
														})}
													</TabsContainer>
												)}

												<GlobalSearch />

												<Box marginLeft="24px" display="flex" alignItems="center">
													<Badge
														badgeContent={totalUnread || 0}
														color="error"
														style={{ cursor: 'pointer' }}
														onClick={() => {
															routerStore.goPage(PATHS.common.notifications)
															logClickEvent(COMMON_EVENT_CLICK_TRACKING.notifBellBtn)
														}}
													>
														<NotificationSvg />
													</Badge>
												</Box>
												<UserAccount />
											</Box>
										</>
									)}
								</Box>
								<Hidden mdUp>
									<AppBar css={bottomAppBarStyle}>
										<BottomNavigation value={activeCode} showLabels>
											{careStore.appbarMenu?.map(({ code, name, icon: Icon, path, isDisabled }) => (
												<BottomNavigationAction
													key={code}
													onClick={() => routerStore.goPage(path)}
													label={t(name)}
													disabled={isDisabled}
													css={isDisabled ? menuDisabledItemStyle : menuItemStyle}
													value={code}
													icon={
														Icon && (
															<SvgIcon
																viewBox="0 0 24 24"
																style={{
																	fill: 'none',
																	color: 'inherit',
																}}
																component={Icon}
															></SvgIcon>
														)
													}
												/>
											))}
										</BottomNavigation>
									</AppBar>
								</Hidden>
							</>
						) : smDown ? (
							<Box display="flex" width="100%" justifyContent="center" flexDirection="column" gridGap={4}>
								<Box
									display="flex"
									alignItems="center"
									justifyContent="space-between"
									pl={3}
									style={{ cursor: 'pointer' }}
									onClick={() => {
										routerStore.goPage(PATHS.common.home)
										logClickEvent(COMMON_EVENT_CLICK_TRACKING.welcomeToGHR)
									}}
								>
									<Box className={'wrapper-logo-brand'} style={{ width: `${logoWidthMapping[appStore.jobBoardCode]}px` }}>
										<img
											src={LogoUrl}
											alt={LogoUrl}
											style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
											width={logoWidthMapping[appStore.jobBoardCode]}
										/>
									</Box>

									<Box className="layout-nav">
										<Box display={'flex'} alignItems={'center'}>
											<Button onClick={handleRedirectSignIn} className={'top-bar-ano-button'} color={'primary'}>
												{t('SIGN_IN')}
											</Button>
											<Button onClick={handleRedirectSignUp} className={'top-bar-ano-button'} variant="outlined">
												{t('SIGN_UP')}
											</Button>
										</Box>
									</Box>
								</Box>
								{/* https://mylong.atlassian.net/browse/GHR-5420 */}
								{/* <Box>
										<Typography variant="subtitle1" color="primary.main" fontWeight={800} style={{ marginLeft: '20px' }}>
											<span dangerouslySetInnerHTML={{ __html: welcomeTextMapping[appStore.jobBoardCode] }} />
										</Typography>
									</Box> */}
								{/* <img src={appStore.welcomeLogo} alt={'logo'} css={[logoStyle, { paddingLeft: '24px' }]} className={appStore.jobBoardCode} /> */}
							</Box>
						) : (
							<>
								{renderHeader()}
								{/* 
								<Box
									display="flex"
									justifyContent="center"
									alignItems="center"
									pl={3}
									gridGap={32}
									style={{ cursor: 'pointer' }}
									onClick={() => {
										routerStore.goPage(PATHS.common.home)
										logClickEvent(COMMON_EVENT_CLICK_TRACKING.welcomeToGHR)
									}}
								>
									<Box className={'wrapper-logo-brand'} style={{ width: `${logoWidthMapping[appStore.jobBoardCode]}px` }}>
										<img
											src={LogoUrl}
											alt={LogoUrl}
											style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
											width={logoWidthMapping[appStore.jobBoardCode]}
										/>
									</Box>
								</Box>

								<Box className={!authStore.id && routerStore.basePath === PATHS.care.global_search ? 'layout-nav fullWidth' : 'layout-nav normal'}>
									<GlobalSearch />
									<Box display={'flex'} alignItems={'center'}>
										<Button onClick={handleRedirectSignIn} className={'top-bar-ano-button'} color={'primary'}>
											{t('SIGN_IN')}
										</Button>
										<Button onClick={handleRedirectSignUp} className={'top-bar-ano-button'} variant="outlined">
											{t('SIGN_UP')}
										</Button>
									</Box>
								</Box> */}
							</>
						)}
					</HeaderBar>
				</>

				<main css={authStore.id ? mainContentStyle : [mainWithoutMenuContentStyle, { marginTop: headerHeight }]}>
					<Breadcumbs onClickBack={customHeader?.onClickBack} title={t(customHeader?.title || activeName)} />
					<Hidden smDown>
						{!appStore.hideBanner && !authStore.id && routerStore.basePath !== PATHS.care.global_search && <Banner isAnonymous={!authStore.id} />}
					</Hidden>
					<Box css={mainContentChildrenStyle}>{children}</Box>

					{renderFooter()}
				</main>

				<Drawer anchor="left" css={sidebarMobileStyle} open={showProfileSidebar} onClose={toogleProfileSidebar}>
					<Box css={closeBtnWrapperStyle} position="fixed" top={2} left="180px" onClick={toogleProfileSidebar}>
						<IconButton>
							<SvgIcon component={CloseSideBarSvg} viewBox="0 0 15 15" style={{ fontSize: 15, fill: 'white' }} />
						</IconButton>
					</Box>

					<List css={drawerBottomStyle}>
						{authStore.id && (
							<>
								{careStore.sidebarMenu.map(({ code, eventId, name, path, icon: Icon, isDisabled }) => {
									return (
										<ListItem
											button
											key={code}
											disabled={isDisabled}
											css={isDisabled ? menuDisabledItemStyle : menuItemStyle}
											selected={code === activeCode}
											eventId={eventId}
											onClick={() => {
												toogleProfileSidebar()
												routerStore.goPage(path)
											}}
										>
											<ListItemIcon className="mobile-responsive">
												{Icon && <SvgIcon viewBox="0 0 24 24" style={{ fill: 'none', color: 'white' }} component={Icon}></SvgIcon>}
											</ListItemIcon>
											<ListItemText className="mobile-responsive" style={{ color: 'white' }} primary={t(name)} />
										</ListItem>
									)
								})}

								{careStore.dropDownMenu.map(({ code, eventId, name, path, icon: Icon }) => {
									return (
										<ListItem
											button
											key={code}
											css={menuItemStyle}
											selected={code === activeCode}
											eventId={eventId}
											onClick={() => {
												toogleProfileSidebar()
												routerStore.goPage(path)
											}}
										>
											<ListItemIcon className="mobile-responsive">
												{Icon && <SvgIcon viewBox="0 0 20 20" style={{ fill: 'none', color: 'white' }} component={Icon}></SvgIcon>}
											</ListItemIcon>
											<ListItemText className="mobile-responsive" style={{ color: 'white' }} primary={t(name)} />
										</ListItem>
									)
								})}
							</>
						)}

						{careStore.privacyPolicyUrl && (
							<ListItem
								button
								css={menuItemStyle}
								eventId="privacy-policy-nav_btn"
								onClick={() => {
									toogleProfileSidebar()
									routerStore.openNewPage(`${process.env.REACT_APP_MARKETING_WEB_SITE}/policy`)
									// routerStore.openNewPage(careStore.privacyPolicyUrl)
								}}
							>
								<ListItemIcon>
									<SvgIcon viewBox="0 0 20 20" style={{ fill: 'none', color: 'inherit' }} component={PrivacySvg}></SvgIcon>
								</ListItemIcon>
								<ListItemText primary={t('PRIVACY_POLICY')} />
							</ListItem>
						)}

						<ListItem button css={menuItemStyle} eventId="logout-nav_btn" onClick={logout}>
							<ListItemIcon>
								<SvgIcon component={LogoutSvg} viewBox="0 0 20 20" style={{ fill: 'none', color: 'inherit' }}></SvgIcon>
							</ListItemIcon>
							<ListItemText primary={t('SIGN_OUT')} />
						</ListItem>

						<Box height="30px"></Box>
					</List>
				</Drawer>
			</div>
			{authStore.isAnonymous && <QuickApply open={openQuickApply} setClose={setOpenQuickApply} />}
			{authStore.id && <ApplyJobDialog setClose={() => careJobDetailStore.setShowApplyDialog(false)} open={careJobDetailStore.showApplyDialog} />}
			<SuccessApplyDialog />

			<NotifyDialog
				open={careActivationStore.isShowDialogSuccessOnboarding}
				okText="I got it"
				onOk={() => careActivationStore.setIsShowDialogSuccessOnboarding(false)}
				title={'Congrats! Your profile is complete'}
				children={`You can still update your profile information anytime later.`}
			/>
			<NotifyDialog
				showButtonClose={true}
				onClose={() => setShowCheckInError(false)}
				open={showCheckinError}
				okText="I got it"
				onOk={() => setShowCheckInError(false)}
				title={'Check-in is only available 1 hour before the assignment start time'}
				children={`Please try again later. Thank you for your understanding. `}
			/>
			<PrivacyPolicyFeature open={showPrivacy} onClose={handleClosePrivacy} />
			<AdditionalInfoApplyDialogComponent />
			<MatchProfessionDialog />
			<CheckoutSuccessDialog />
			<SuccessCheckinDialog />
		</>
	)
})
